import { PayloadAction } from '../../../store.model';
import { ColumnId, SortOptions } from '../../table';
import { NO_SCORE_NO_CLASS_ID } from '../fixture/no-score-no-class-id';
import { determineFilterItems } from '../function/determine-filter-items.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../main.action';
import { TranslationKeyMap } from '../main.i18n';
import { MainState } from '../main.state';
import { performerItemViewTransformer } from '../transformer/performer-item-view.transformer';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: MainState,
    _: PayloadAction<ActionType.MI2_MAIN__RELOAD, Reload>,
): MainState {
    return {
        ...state,
        pending: {
            ...state.pending,
            reload: true,
        },
    };
}

export function reloadResultReducer(
    state: MainState,
    action: PayloadAction<ActionType.MI2_MAIN__RELOAD_RESULT, ReloadResult>,
): MainState {
    try {
        action.payload.data?.improvementCategories?.forEach((e) => {
            e.groups?.sort((a, b) => {
                return a.displayOrder - b.displayOrder;
            });
        });

        action.payload.data?.improvementCategories?.sort((a, b) => {
            return a.displayOrder - b.displayOrder;
        });

        const nextCategories =
            action.payload.data?.improvementCategories?.filter(
                (e) =>
                    e.scorecardImprovementCategoryId !== NO_SCORE_NO_CLASS_ID,
            );
        const nextNoScoreCategory =
            action.payload.data?.improvementCategories?.find(
                (e) =>
                    e.scorecardImprovementCategoryId === NO_SCORE_NO_CLASS_ID,
            );

        // TODO revise
        if (nextNoScoreCategory != null) {
            nextNoScoreCategory.scorecardImprovementCategoryName =
                TranslationKeyMap._9879_NO_SCORE;
        }

        // TODO move
        const nextDates = action.payload.data?.dates;
        if (nextDates?.startDate != null) {
            nextDates.startDate = new Date(nextDates.startDate);
        }
        if (nextDates?.endDate != null) {
            nextDates.endDate = new Date(nextDates.endDate);
        }
        if (nextDates?.previousStartDate != null) {
            nextDates.previousStartDate = new Date(nextDates.previousStartDate);
        }
        if (nextDates?.previousEndDate != null) {
            nextDates.previousEndDate = new Date(nextDates.previousEndDate);
        }
        if (nextDates?.createdOn != null) {
            nextDates.createdOn = new Date(nextDates.createdOn);
        }

        const nextDirectReports = performerItemViewTransformer(
            action.payload.data?.directReports,
        );

        const nextFilterItems = determineFilterItems(
            action.payload.data?.improvementCategories,
            nextDirectReports,
        );

        const nextSortOptions: SortOptions = {
            columnId: ColumnId.MI2_SCORE,
            order: 'desc',
        };
        const nextFilteredDirectReports = sortRows(
            nextDirectReports,
            nextSortOptions,
        );

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            categories: nextCategories,
            noScoreCategory: nextNoScoreCategory,
            dates: nextDates,
            rows: nextDirectReports,
            sortOptions: nextSortOptions,
            filteredRows: nextFilteredDirectReports,
            currentPerformanceClassFilterItems:
                nextFilterItems.currentPerformanceClasses,
            previousPerformanceClassFilterItems:
                nextFilterItems.previousPerformanceClasses,
            improvementGroupFilterItems: nextFilterItems.improvementGroups,
            populationGroupImprovementGroups:
                action.payload.data?.populationGroupImprovementGroups,
        };
    } catch {
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            categories: null,
            noScoreCategory: null,
            dates: null,
            rows: null,
            sortOptions: null,
            filteredRows: null,
            currentPerformanceClassFilterItems: null,
            previousPerformanceClassFilterItems: null,
            improvementGroupFilterItems: null,
            populationGroupImprovementGroups: null,
        };
    }
}
